module.exports = __webpack_public_path__ + "static/img/rtwwoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/rtwwoman.jpg
// module id = tA5U
// module chunks = 1